export enum HubspotJobChangeIntegrationModeEnum {
  CREATE_NEW_ASSOCIATE = "CREATE_NEW_ASSOCIATE",
  CREATE_NEW = "CREATE_NEW",
  UPDATE_OLD = "UPDATE_OLD"
}
